module.exports = __webpack_public_path__ + "img/sunny.f5643ecd.png";